import { TableSchema } from '../metadata-schema';
import { IndicatorCode } from '../enums/IndicatorCode';
import { IndicatorNaam } from '../enums/IndicatorNaam';
import { Niveau } from '../enums/Niveau';

export const dim_no_norm_onderwijsresultaat: TableSchema = {
	"$schema": "https://json-schema.org/draft/2020-12/schema",
	"title": "dim_no_norm_onderwijsresultaat",
	"description": "Definitie voor dimension tabel dim_no_norm_onderwijsresultaat uit de CumLaude DWH",
	"type": "object",
	"implements": [
		"nl.topicus.cumlaude.metadata.table.DimTable",
		"nl.topicus.cumlaude.metadata.table.Landelijk"
	],
	"properties": {
		"no_co_indicator": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			},
			"type": "string",
			"schema": IndicatorCode
		},
		"no_d_geldig_tot": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"no_d_geldig_va": {
			"type": "string",
			"format": "date",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nm_indicator": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			},
			"type": "string",
			"schema": IndicatorNaam
		},
		"no_nm_soort_onderwijs": {
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			},
			"type": "string",
			"schema": Niveau
		},
		"no_nm_vergelijkgroep": {
			"type": "string",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_apcg_corr_factor": {
			"type": "number",
			"label": "APCG-correctiefactor",
			"category": "Norm",
			"filter": false,
			"grouping": false,
			"searchKeys": [
				"Armoedeprobleemcumulatiegebied",
				"postcode"
			],
			"example": "-0,25",
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_instroom_corr_factor": {
			"type": "number",
			"label": "Instroom-correctiefactor",
			"category": "Norm",
			"filter": false,
			"grouping": false,
			"example": "-4,5",
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_jobrun": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_lwoo_corr_factor": {
			"type": "number",
			"label": "LWOO-correctiefactor",
			"category": "Norm",
			"filter": false,
			"grouping": false,
			"searchKeys": [
				"Leerwegondersteund onderwijs"
			],
			"example": "-2",
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_norm": {
			"type": "number",
			"label": "Landelijke norm",
			"category": "Norm",
			"filter": false,
			"grouping": false,
			"example": "95,5",
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_norm2": {
			"type": "number",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_opstroom_corr_factor": {
			"type": "number",
			"label": "Opstroom-correctiefactor",
			"category": "Norm",
			"filter": false,
			"grouping": false,
			"example": "-0,6",
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_peiljaar": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"no_nr_versie": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		},
		"no_pk_key": {
			"type": "integer",
			"filter": false,
			"grouping": false,
			"exportable": false,
			"blocklist": {
				"geenVO": true
			}
		}
	}
};
